export enum ChecklistItemTypeEnum {
  PASS_FAIL = 'PASS_FAIL',
  NUMERIC = 'NUMERIC',
  TEXT = 'TEXT',
  // CHECKBOX = 'CHECKBOX',
}

export type ChecklistItemType = keyof typeof ChecklistItemTypeEnum;

export const ChecklistItemValueEnum = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  NA: 'NA',
} as const;

export type ChecklistItemValue =
  (typeof ChecklistItemValueEnum)[keyof typeof ChecklistItemValueEnum];

export type ChecklistItem = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  label: string;
  description: string | null;
  type: ChecklistItemType;
  isRequired: boolean;
  order: number;
  checklistId: number;
};

export type InspectionChecklist = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  name: string;
  description: string | null;
  organizationId: number | null;
  items: ChecklistItem[];
};

export type ChecklistItemAnswer = {
  id: number;
  snapshotLabel: string;
  snapshotDescription: string | null;
  snapshotType: ChecklistItemType;
  snapshotOrder: number;
  value: ChecklistItemValue | null;
  numericValue: number | null;
  textValue: string | null;
  comment: string | null;
};

export type ChecklistResult = {
  id: number;
  checklistId: number | null;
  snapshotChecklistName: string;
  answers: ChecklistItemAnswer[];
};
